/** @import module */

import cookies                          from "js-cookie";

import { NavLink }                      from "react-router-dom";

import { useTranslation }               from "react-i18next";

/** @import models */

import TechInfoModel                    from "../../../Models/TechnicalModel";

/** @import components */

import ComponentLoader                  from "../../Layout/Loaders/Loader";

/**
 * 
 * @returns services navigation widget component
 * 
 */

const Navigation = () => { const { t } = useTranslation (),
    
    { loading, data } = TechInfoModel (),

    /** @returns services collection */

    Collection = ( { object, status } ) => {

        /** load component fallback */

        if ( status ) return <ComponentLoader />

        /** filter by active entries and language */

        const filter = object.technicalInformation.edges.filter ( obj => obj.node.language === cookies.get ( 'i18next' ) && obj.node.isPublished === true );

        return filter.map ( ( techinfo, index ) => <li key={ index }>

            <NavLink to={ `/${ t ( "__permalink_content__" ) }/${ t ( "__permalink_techinfo__" ) }/${ techinfo.node.id }/${ encodeURIComponent ( techinfo.node.title ) }` } className={ ( { isActive } ) => ( isActive ? 'active' : 'inactive' ) }>

                { techinfo.node.title }

            </NavLink>

        </li> );

    }

    /** @return component */

    return ( <div className="navigation">

        <ul>

            <Collection object={ data } status={ loading } />

        </ul>

    </div> );

}

/** @export Navigation */
 
export default Navigation;